import pluralNouns from 'shared/dist/pluralNouns';

export default function isPluralCharacter(text: string) {
    return pluralNouns.includes(text.replace(/[^a-z0-9]/gi, '').toLowerCase());
}